import { Locales } from "./locales";

import de from "./de.json"
import fr from "./fr.json"
import it from "./it.json"
import en from "./en.json"

export const messages = {
    [Locales.DE]: de,
    [Locales.FR]: fr,
    [Locales.IT]: it,
    [Locales.EN]: en,
};

export const defaultLocale = Locales.DE;